import Resource, {BaseResource} from './Resource';
import {BaseSignableDocuments} from "./SignableDocuments";

/**
 * Deal Resource
 */
class Deal extends Resource
{
    constructor() {
        super('deal', ['deals']);
    }

    options(params) {
        return this._doGet(['options'], params);
    }

    search(query, params = {}, config = {}) {
      params = Object.assign(params, { query });

      return this._doGet(['search'], params, config);
    }

    additionalDocumentDescriptions() {
        return this._doGet(['additional-document-descriptions'])
    }

    newAutoProtectQuote(id) {
        return this._doPost([id, 'new-autoprotect-quote'])
    }

   assign(id, params = {}) {
        return this._doPut([id, 'assign'], params);
    }

    complete(id, params = {}) {
        return this._doPut([id, 'complete'], params);
    }

    uncomplete(id, params = {}) {
        return this._doPut([id, 'uncomplete'], params);
    }
    
    sundries() {
        return this._doGet(['sundries'])
    }

    gapRti() {
        return this._doGet(['gap-rti'])
    }

    updateGapAuditLog(id, data) {
        return this._doPost([id, 'gap'], data)
    }
}   

export let DealResource = new Deal();

export class SignableDealDocuments extends BaseSignableDocuments
{
    constructor() {
        super('deals');
    }

    forDeal(deal_id) {
        return this.forModel(deal_id)
    }
}

export let SignableDealDocumentsResource = new SignableDealDocuments()

export let DocumentSigningRequestTypes = {
    IN_PERSON:'in-person',
    REMOTE: 'remote'
}

export let DocumentSigningStatuses = {
    OUT_FOR_SIGNING: 'out_for_signing',
    SIGNED: 'signed',
    DECLINED: 'declined',
    CANCELLED: 'cancelled',
    DRAFT: 'draft',
    PROVIDER_ERROR: 'provider_error',
}
/**
 * GapAuditEntry Schema
 * @param {Object} defaults [description]
 */
export let GapAuditEntrySchema = function(defaults = {}) {
    let schema = {
        'deal_id': null,
        'is_gap_recommended': null,
        'customer_declined_to_discuss': null,
        'is_customer_insuring': null,
        'does_customer_insurer_new_for_old': null,
        'is_customer_financing': null,
        'customer_finance_length': null,
        'is_customer_responsible_for_finance': null,
        'discussed_at': null,
        'is_customer_considering': null,
        'is_customer_purchasing': null,
        'policy_number': null,
        'policy_type': null,
        'policy_duration': null,
        'policy_claim_limit': null,
        'policy_activated_at': null,
        'vehicle_use': null,
        'purchased_at': null,
        'deposit_prompt_at': null,
        'sku': '',
    };

    if (defaults) {
        schema = Object.assign(schema, defaults);
    }

   return schema;
};

/**
 * [DealSchema description]
 * @param {Object} defaults [description]
 */
export let DealSchema = function(defaults = {}) {
    let schema = {
        location_id: null,
        invoice_id: null,
        instance_id: null,
        completed_at: null,
        completed_by_id: null,
        handover_at: null,
        referral_source_id: null,
        notes: null,
        margin: null,
        sales_person_id: null,
        sales_person: null,
        export_type: null,
        vehicle_use_type: null,
        is_distance_sale: false,
        offer_generated_at: null,
        offer_presented_at: null,
        offer_cash_deposit: null,
    };

    if (defaults) {
        schema = Object.assign(schema, defaults);
    }

   return schema;
}

export let DealLifeCycleStatuses = {
    DRAFT: 5,
    IN_PROGRESS: 10,
    COMPLETED: 15,
    REFUNDED: 20,
    CANCELLED: 25,
};

export const DealExportTypes = {
    NONE: null,
    STANDARD: 'standard',
    ZERO_RATED: 'zero_rated',
}

export const DealExportTypeList = [
    { value: DealExportTypes.NONE, label: 'None' },
    { value: DealExportTypes.STANDARD, label: 'Standard Rated / Margin (In-direct Export)' },
    { value: DealExportTypes.ZERO_RATED, label: 'Zero Rated (Direct / Personal Export)' },
]

export const DealUseTypes = {
    USE_PRIVATE: 'private',
    USE_COMMERCIAL: 'commercial',
    USE_LIFESTYLE: 'lifestyle',
    USE_HIRE_AND_REWARD: 'hire_and_reward',
    USE_MOTABILITY: 'motability',
}

export const DealUseTypeList = [
    {
        value: DealUseTypes.USE_PRIVATE,
        label: 'Private',
        description: 'Social Domestic, Pleasure and Commuting – You will use the vehicle for normal day to day driving. Shopping, visiting friends or family, pleasure driving such as going to the park or on holiday and driving to and from a permanent place of work'
    },
    {
        value: DealUseTypes.USE_COMMERCIAL,
        label: 'Commercial',
        description: 'You will use vehicle car as part of your job, to drive to other sites as well as your usual place of work, It doesn\'t include Hire and Reward'
    },
    {
        value: DealUseTypes.USE_LIFESTYLE,
        label: 'Lifestyle',
        description: 'Your vehicle is classed as a light commercial vehicle however you will only use it for a lifestyle or hobby activity, for example a LCV used to transport fishing or windsurfing equipment'
    },
    {
        value: DealUseTypes.USE_HIRE_AND_REWARD,
        label: 'Hire & Reward',
        description: 'You will use your vehicle for delivery or couriering or as a taxi or minicab or limo, or you will use your vehicle to give paid driving lessons'
    },
    {
        value: DealUseTypes.USE_MOTABILITY,
        label: 'Motability',
        description: 'The vehicle is being sold on Motability Contract Hire'
    },
]